@if (!getExperimentError) {
  <div id="title--container">
    <h4>Device Setup</h4>
    @if (error) {
      <span class="error">{{ error?.message }} </span>
    }
    <h5>{{ laboratory.laboratoryName }}</h5>
  </div>
  <hr />
}
@if (experiment) {
  <div id="inner-page--container">
    <div id="action--toolbar">
      <app-mat-icon-button
        buttonStyle="primary"
        buttonId="remove-btn"
        iconName="arrow_back"
        ariaLabel="Back"
        (buttonClicked)="goBack()"
      ></app-mat-icon-button>
      <div class="experiment-name">
        <h6>
          {{ experiment.name }}
        </h6>
        @if (experiment) {
          <app-status-indicator
            [status]="ExperimentStatus[experiment?.experimentStatusId]"
          ></app-status-indicator>
        }
      </div>
      <app-icon-button
        label="delete draft"
        buttonStyle="negative"
        buttonId="delete-draft-btn"
        iconName="delete"
        buttonShape="square"
        (click)="openModal('delete-draft')"
        [isDisabled]="
          isProcessing ||
          deleteIsProcessing ||
          !(currentUser.role
            | roleCheck: labAdminRoles)
        "
      ></app-icon-button>
    </div>
    <hr />
    @if (devices) {
      <div id="device--container">
        @for (device of devices; track device.id) {
          <app-device-setup-row
            [device]="device"
            [deviceComplete]="
              device.deviceStatusId === DeviceSetupStatus.FlasksInserted
            "
            [showMorbidostatWarning]="showMorbidostatWarning()"
          ></app-device-setup-row>
        }
      </div>
      <hr />
      <div id="button--container">
        <app-button
          label="start experiment"
          buttonId="start-btn"
          buttonStyle="positive"
          (buttonClicked)="startExperiment()"
          [isDisabled]="startExperimentButtonDisabled"
          [isProcessing]="isProcessing"
        ></app-button>
      </div>
    }
  </div>
}
@if ((isProcessing || pageIsLoading) && !experiment) {
  <div id="loading--container">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
@if (getExperimentError && !pageIsLoading) {
  <app-error-page
    [primaryText]="getExperimentError?.message"
  ></app-error-page>
}
@if (deviceError && !pageIsLoading) {
  <div id="error--container">
    <p class="error">Error: {{ deviceError.message }}</p>
  </div>
}
<app-modal
  id="morbidostat-warning"
  titleText="Attention"
  primaryText="Morbidostat mode requires an external pump module. Please confirm you have this installed."
  buttonLayout="double-button"
  primaryButtonText="Confirm"
  primaryButtonId="morbidostat-confirm"
  secondaryButtonText="Cancel"
  secondaryButtonId="morbidostat-cancel"
  modalStyle="warning"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="experiment-started"
  titleText="Experiment Started"
  animationType="test-tubes"
  buttonLayout="double-button"
  primaryButtonText="View active experiment"
  primaryButtonId="view-exp-btn"
  secondaryButtonText="Go to dashboard"
  secondaryButtonId="dashboard-btn"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="error?.message"
  primaryButtonText="close"
  primaryButtonId="close-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-validation-modal
  id="delete-draft"
  titleText="Delete draft?"
  validationText="delete"
  primaryButtonText="Confirm delete"
  primaryButtonId="confirm-delete-button"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-delete-button"
  (modalButtonClicked)="deleteDraft()"
  [error]="deleteError"
></app-validation-modal>
<app-modal
  id="delete-success"
  titleText="Success"
  primaryText="Experiment draft was deleted."
  primaryButtonText="Go to dashboard"
  primaryButtonId="delete-success-button"
  modalStyle="success"
  (modalButtonClicked)="modalButtonClicked($event)"
  [allowClose]="false"
>
</app-modal>
<app-modal
  id="delete-error"
  titleText="Unable to delete draft"
  [primaryText]="deleteError?.message + '. Choose an action below'"
  buttonLayout="double-button"
  primaryButtonText="Go to dashboard"
  primaryButtonId="error-primary-button"
  secondaryButtonText="Close"
  secondaryButtonId="error-secondary-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
  [allowClose]="false"
>
</app-modal>
